import axios from '../../../../utils/AxiosUtils';
import i18n from '../../../../i18next';

import {
    LOADING,
    LOAD_POS_SETTINGS_SUCCESS,
    LOAD_POS_TYPES_SUCCESS,
    UPDATE_POS_SETTINGS_SUCCESS,
    CLEAR_POS_SETTINGS,
    RESET_QUESTIONS,
    RESET_ANSWERS,
    RESET_PRODUCTS,
    RESET_CATEGORIES,
    RESET_SUB_ANSWERS,
    RESET_SUB_QUESTIONS,
    LOAD_MENUS_SUCCESS,
    IMPORT_IN_PROGRESS,
    IMPORT_IN_PROGRESS_FINISHED // TODO needs refactor
} from '../../../types';
import MessageUtils from '../../../../utils/MessageUtils';
import { convertStringToBoolean } from '../../../../utils/CommonUtils';
import { loadRestaurant } from '../../RestaurantsActions';

export const loadPosSettings = (restaurantId) => {
    return (dispatch) => {

        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant/${restaurantId}/pos-settings`;

        axios().get(url)
            .then(response => posSuccess(dispatch, response.data.data[0], LOAD_POS_SETTINGS_SUCCESS, restaurantId))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:posSettings.loadPosSettingsFailure')));
    };
};

export const loadPosTypes = () => {
    return (dispatch) => {

        dispatch({ type: LOADING, payload: true });

        const url = `/pos-type`;

        axios().get(url)
            .then(response => posSuccess(dispatch, response.data, LOAD_POS_TYPES_SUCCESS))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:posSettings.loadPosTypesFailure')));
    };
};


export const savePosSettingsData = (state, restaurantId) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });
        const url = `/restaurant/${restaurantId}/pos-settings`;

        const calculatedSettings = {};
        const posTypeTemplateFieldsString = state.type.template.replace(/\"/g, "").replace(/\[/g, "").replace(/\]/g, "").replace(/\ /g, "");

        const posTypeTemplateFields = posTypeTemplateFieldsString.split(",");

        posTypeTemplateFields.map((item) => {
            calculatedSettings[item] = state[item];
        });

        let autoSync = convertStringToBoolean(state.autoSync);
        let autoSyncHour = Number(state.autoSyncHour);
        let autoSyncMinute = Number(state.autoSyncMinute);

        if (autoSync === false) {
            autoSyncHour = null;
            autoSyncMinute = null;
        }


        if (autoSync === true && (state.autoSyncHour == null || state.autoSyncMinute == null)) {
            MessageUtils.dispatchErrorMessage(dispatch, i18n.t('common:validations.fillAutoSyncTime'));
            return;
        }

        const posSettings = {
            id: state.id,
            allowToppingsSubstitution: state.allowToppingsSubstitution,
            autoSync: autoSync,
            autoSyncHour: autoSyncHour,
            autoSyncMinute: autoSyncMinute,
            kioskQuestionsOnly: state.kioskQuestionsOnly,
            settings: JSON.stringify(calculatedSettings),
            type: {
                id: state.type.id,
                supportChargeTypes: state.type.supportChargeTypes,
                supportOrderTypes: state.type.supportOrderTypes,
                supportTenderTypes: state.type.supportTenderTypes,
                template: state.type.template,
                value: state.type.value
            }
        };

        axios().post(url, posSettings)
            .then(response => posSuccess(dispatch, response.data, UPDATE_POS_SETTINGS_SUCCESS, restaurantId))
            .catch(error => savePosSettingsDataError(dispatch, error));
    };
};

const posSuccess = (dispatch, response, actionType, restaurantId) => {

    if (actionType == UPDATE_POS_SETTINGS_SUCCESS) {
        MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:posSettings.saveSuccess'));
    }

    if (restaurantId && restaurantId > 0) {
        dispatch(loadRestaurant(restaurantId));
    }

    dispatch({ type: LOADING, payload: false });
    dispatch({ type: actionType, payload: response });
};

const savePosSettingsDataError = (dispatch, error) => {
    dispatch({ type: LOADING, payload: false });

    if (error !== undefined && error.response.data.userMessage === i18n.t('actions:posSettings.userMessage')) {
        MessageUtils.dispatchErrorMessage(dispatch, i18n.t('common:validations.settingsFirstMsg'));
    } else if (error.response !== undefined) {
        MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:posSettings.savePosSettFailure'));
    } else {
        MessageUtils.dispatchErrorMessage(dispatch, i18n.t('actions:posSettings.somethingWrong'));
        // console.log(error);
    }
}

export const clearPosSettings = (dispatch) => {
    return (dispatch) => {
        dispatch({ type: CLEAR_POS_SETTINGS });
    }
}

export const importMenu = (restaurantId, callback) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant/${restaurantId}/import-menu`;

        axios().get(url)
            .then(response => importMenuSuccess(dispatch, response, restaurantId, callback))
            .catch(error => importMenuError(dispatch, error));
    };
};

export const importMenuFromCSV = (restaurantId, files, callback) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant/${restaurantId}/import-menu-csv`;
        const header = { headers: { 'Content-Type': 'multipart/form-data' } }

        const formData = new FormData();
        Object.keys(files).map((fileName, index) => {
            const file = files[fileName];
            formData.append(fileName, file);
        });

        axios().post(url, formData, header)
            .then(response => importMenuSuccess(dispatch, response, restaurantId, callback, header))
            .catch(error => importMenuError(dispatch, error));
    };
};

const importMenuError = (dispatch, error) => {
    if (error.response !== undefined) {
        MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:posSettings.importMenuFailure'));
    } else {
        console.log(error);
    }
}

const importMenuSuccess = (dispatch, response, restaurantId, callback, header) => {

    // TODO - NEEDS CODE REFACTOR
    if (response.data.userMessage === null) {
        const url = `/restaurant/${restaurantId}/menu-draft`;

        axios().get(url, header && header)
            .then(response => loadMenusSuccess(dispatch, response, callback))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:menusActions.loadMenusFailure')));
    } else {
        MessageUtils.dispatchErrorMessage(dispatch, i18n.t('actions:posSettings.importIncorrectSettings'));
    }
};

export const exportMenu = (restaurantId) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant/${restaurantId}/export-menu`;

        axios().get(url)
            .then(response => {
                dispatch({ type: LOADING, payload: false });
                // Open the file for download
                window.open(response.config.url, '_blank');
            })
            .catch(error => {
                dispatch({ type: LOADING, payload: false });
                MessageUtils.errorMessageResponse(dispatch, error.response.data, error.response.data.userMessage);
            });
    };
};

const loadMenusSuccess = (dispatch, response, callback) => {
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:posSettings.importMenuSuccess'));

    dispatch({ type: LOADING, payload: false });
    dispatch({ type: IMPORT_IN_PROGRESS, payload: true });
    dispatch({ type: RESET_CATEGORIES });
    dispatch({ type: RESET_PRODUCTS });
    dispatch({ type: RESET_QUESTIONS });
    dispatch({ type: RESET_ANSWERS });
    dispatch({ type: RESET_SUB_QUESTIONS });
    dispatch({ type: RESET_SUB_ANSWERS });
    dispatch({ type: LOAD_MENUS_SUCCESS, payload: response.data });
    if (callback) {
        callback();
    }
};

export const importMenuFinished = (dispatch) => {
    dispatch({ type: IMPORT_IN_PROGRESS_FINISHED, payload: false });
}

export const wipeMenu = (restaurantId) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });
        MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:posSettings.wipeStarting'));

        const url = `/restaurant/${restaurantId}/wipe-menu`;

        axios().put(url, {})
            .then(response => {
                dispatch({ type: LOADING, payload: false });
            })
            .catch(error => {
                dispatch({ type: LOADING, payload: false });
                MessageUtils.errorMessageResponse(dispatch, error.response.data, error.response.data.userMessage);
            });
    }
}

export const sendMenuuOrderHubLogs = (targetEmail) => {
    return (dispatch, getState) => {
        dispatch({ type: LOADING, payload: true });

        const email = targetEmail == undefined ? null : targetEmail;
        const restaurantId = getState().restaurant.id;

        const url = `/menuu-pos/${restaurantId}/request-log?targetEmail=${email}`;

        axios().get(url)
            .then(response => {
                dispatch({ type: LOADING, payload: false });
                MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:posSettings.sendLogsSuccess'));
            })
            .catch(error => {
                dispatch({ type: LOADING, payload: false });
                MessageUtils.errorMessageResponse(dispatch, error.response.data, error.response.data.userMessage);
            });
    }
}

export const activateMenu = (restaurantId) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/ordermark/restaurant/${restaurantId}/activate`;

        axios().post(url, {})
            .then(response => {
                dispatch({ type: LOADING, payload: false });
                MessageUtils.dispatchSuccessMessage(dispatch, response.data.userMessage);
            })
            .catch(error => {
                dispatch({ type: LOADING, payload: false });
                MessageUtils.errorMessageResponse(dispatch, error.response.data, error.response.data.userMessage);
            });
    }
}


// WEBPACK FOOTER //
// ./src/actions/restaurants/settings/pos/PosSettingsActions.js